export default {
  translation: {
    modals: {
      deleteProductQuestion: "Sei sicuro di eliminare questo elemento?",
      welcome: "Ti sei registrato nel sistema DAB, effettua la login al D.Shop",
      newUser: "Benvenuto su D.Shop",
      agentBudget:
        "Hai scelto di utilizzare il budget di un agente che verrà modificato in base all'ordine che stai effettuando",
      orderSent: "Congratulazioni, hai inviato il tuo ordine!",
      endBudget: "Hai superato il valore del paniere per quest'anno.",
      errorBudgetTitle: "Errore Budget",
      errorBudgetDescription:
        "Budget errato. Se pensi che questo sia un errore, contattare l'amministratore",
      orderRepeatModal: {
        buttonDetail: "Ripeti Ordine",
        emptyCart: {
          title: "I Prodotti sono stati aggiunti al carrello",
          button1: "Continua con lo shopping",
          button2: "vai alla cassa",
        },
        notEmptyCart: {
          title: "I prodotti presenti nel carrello verranno rimossi",
          description:
            "I prodotti dell'ordine selezionato verranno aggiunti al carrello, potrai aggiungere altri prodotti in un secondo momento",
          button1: "Annulla",
          button2: "Procedi",
        },
        emptyCartCase4: {
          title: "Alcuni prodotti o le quantità scelte non sono disponibili",
          description:
            "I prodotti disponibili verranno aggiunti al carrello, per i seguenti prodotti è necessario controllare le disponibilità: ",
          button1: "Annulla",
          button2: "Procedi",
        },
      },
    },
    buttons: {
      deleteProduct: "Elimina prodotto",
      cancel: "Annulla",
      getPdf: "Ottieni PDF",
      completeRegistration: "Completa Registrazione",
      close: "Chiudi",
      visitSite: "Visita il sito",
      back: "< Indietro",
      getOrderPdf: "Scarica il PDF dell'ordine",
      proceedOrder: "Continua con l'ordine",
      visitAfterOrder: "Continua a visitare il sito",
      goOrders: "Vai ai tuoi ordini",
      sendOrder: "Invia l'ordine",
      addToCart: "Aggiungi al carrello",
      goCheckout: "Vai al checkout",
      resetCart: "Svuota carrello",
      discoverMore: "Scopri di più",
    },
    errors: {
      cartError: "Errore nel reperimento del carrello",
      fieldsRegisterError: "Errore nella compilazione dei campi",
      formError: "Errore nel reperimento del form di registrazione",
      pageLoadingError: "Errore nel caricamento della pagina",
      generalError: "Si è verificato un errore",
      purchaseError: "Errore nell'acquisto",
      purchaseErrorDescription: "Ricarica la pagina e riprova",
      quantityPurchaseError: "Quantità richiesta non disponibile",
      quantityPurchaseErrorDescription: "Selezionare una quantità minore",
      listError: "Errore nel reperimento dei prodotti",
      noProducts: "Nessun prodotto trovato",
      noProductsDescription: "Visita le altre categorie",
      addressesError: "Errore nel reperimento degli indirizzi",
      addressNotFound:
        "Nessuna corrispondenza. Riprovare la ricerca con un nuovo nome.",
      sendOrderError: "Errore nell'invio dell'ordine",
      sendOrderErrorDesc:
        "Prova a ricaricare la pagina e ricontrolla tutti i dati.",
      productError: "Errore nel reperimento del prodotto",
    },
    formFields: {
      vatField: "VAT Number / Codice Fiscale",
      mainBusinessField: "Main Business Area",
      companyNameField: "Nome Azienda",
      addressField: "Indirizzo",
      addressContField: "Indirizzo (cont.)",
      postalCodeField: "CAP",
      cityField: "Città",
      provinceField: "Provincia",
      countryField: "Paese",
    },
    content: {
      whyRegister: "Perchè dovresti regitrarti al sito?",
      filterType: "Filtro per tipo",
      filterLanguage: "Filtro per lingua",
      lastInsertedProducts: "Ultimi prodotti inseriti",
      orderName: "Ordina per nome del prodotto",
      orderDate: "Ordina per data di creazione",
      orderByType: "Ordina per tipo",
      orderBy: "Ordina per...",
      orderBudget: "Il tuo ordine è per il DTraining o per un'Azienda?",
      orderBudgetDesc: "Seleziona tipologia",
      orderLocation: "Ordine CEE o extra-CEE?",
      orderLocationDesc: "Seleziona tipologia",
      orderType: "Omaggio o vendita?",
      orderTypeDesc: "Seleziona tipologia",
      homage: "Omaggio",
      sale: "Vendita",
      lastOrder: "Ultimo indirizzo di spedizione",
      searchAddress: "Ricerca l'indirizzo",
      order: "Ordine",
      orderNotes: "Note ordine",
      editOrderNotes: "Modifica note",
      addOrderNotes: "Aggiungi le note dell'ordine",
      saveOrderNotes: "Salva note",
      getPdfMail: "Ricevi il PDF di riassunto dell'ordine via email",
      articles: "Articoli",
      addedItem: "Hai appena aggiunto un prodotto al carrello",
      documentation: "Documentazione",
      getCatalogue: "Download demo",
      search: "Cerca",
      ourProduct: "I nostri prodotti",
      relatedProducts: "Potrebbe interessarti anche...",
    },
    productDetail: {
      selectSize: "Seleziona una taglia",
      quantity: "Quantità",
      pieces: "Pezzi",
      availability: "Disponibilità in magazzino",
      description: "Descrizione",
      detail: "Dettaglio",
    },
    orderTable: {
      totalPrice: "Totale Ordine",
      orderDate: "Data Ordine",
      orderCode: "Codice Ordine",
      customerName: "Cliente",
      statusOrder: "Status",
      removed: "Rimosso dal database",
      repeatOrder: "Ripeti",
    },
    menu: {
      cart: "Carrello",
      emptyCart: "Il tuo carrello è vuoto.",
      emptyCartDesc:
        'Per aggiungere articoli al tuo carello naviga fra le categorie: quando trovi un prodotto che ti interessa, clicca su "Aggiungi al carrello". Il prezzo degli oggetti nel tuo carrello richiama sempre il prezzo più aggiornato mostrato nel dettaglio prodotto.',
      signUp: "Registrazione",
      myOrders: "I miei ordini",
      language: "Lingua",
      selectLanguage: "Seleziona lingua",
      showPrices: "Mostra prezzi",
      select: "Seleziona...",
      selectCurrency: "Seleziona valuta",
      totalActual: "Totale Attuale",
      totalAnnual: "Totale Annuale",
      editProfile: "Modifica profilo",
    },
  },
};



// WEBPACK FOOTER //
// ./src/I18n/locales/it.js